import React from 'react';
import './Home.scss';
import IntroText from './components/IntroText/IntroText';
import Footer from './components/Footer/Footer';
import SEO from '../../components/SEO/SEO';

const Home = props => {
  return (
    <>
      <SEO
        title="Moid Hasan Beig - Full Stack Developer | Portfolio"
        description="Software developer based in Montreal, Canada. Full stack developer specializing in clean, thoughtful UIs and frontend development. Check out my projects and connect with me."
        keywords="Moid Hasan Beig, full stack developer, frontend developer, UI developer, software developer, Montreal, React, JavaScript, portfolio"
        path="/"
      />
      <div className="home-page">
        <IntroText />
        <Footer />
      </div>
    </>
  );
};

export default Home;
